import React, {useEffect, useState, Suspense, lazy } from 'react';
import {inject, observer} from 'mobx-react';
import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';
import {PopUp} from './Presentational Components/PopUp';
import noInternet from './images/no internet.png';
import {storageService} from './services/storageService';
import AiFactory from './pages/AiFactory';
import AuthenticationWithEnable from './HOC/AuthenticationWithEnable';
import {request} from './services/HttpRequestService';
import wong from './images/something went wrong.png';
import ProductFruits from 'react-product-fruits';
import {_requests, _SYSTEM_TITLES} from './configuration/index.config';
import Button from './Presentational Components/Button';
import Loading from './Presentational Components/Loading';
import WarningToggleSmall from './Presentational Components/warningToggle/View/WarningToggleSmall.view';
import {useWebSocket} from './Custom Hooks/useWebSocket/useWebSocket';
import useGlobalToggles from './Custom Hooks/useGlobalToggles/useGlobalToggles';
import useWindowDimensions from './Custom Hooks/useWindowDimensions/useWindowDimensions';
import windowGlobalEvents from './services/WindowGlobalEvents';
import useSentry from './Custom Hooks/useSentry/useSentry';
import useVIToggle from './Custom Hooks/useVIToggle/useVIToggle';
import CreateAutoClassificationProject from './pages/CreateAutoProject/View/CreateAutoProject.view';
import {ManualRefinement} from './pages/ManualRefinement';
import AutoProjectView from './pages/AutoProject/View/AutoProject.view';
import {RandomSampler} from './pages/RandomSampler';
const DataFileManagement = lazy(() => import('./pages/DataFileManagement'));
const Main = lazy(() => import('./pages/main/Main'));
const Login = lazy(() => import('./pages/Login'));
const AnalyzeDebug = lazy(() => import('./pages/AnalyzeDebug'));
const Settings = lazy(() => import('./pages/settings/Settings'));
const ObjectIdentification = lazy(() => import('./pages/classification/Classification'));
const Configuration = lazy(() => import('./pages/Configuration'));
const FaceRecognition = lazy(() => import('./pages/FaceRecognition'));
const DataProjects = lazy(() => import('./pages/DataProjects'));
const Tagging = lazy(() => import('./pages/Tagging'));
const {tokenExpireModal} = _SYSTEM_TITLES;
const SettingsWrapper = AuthenticationWithEnable(Settings);
const ClassificationWrapper = AuthenticationWithEnable(ObjectIdentification);
const AnalyzeDebugWrapper = AuthenticationWithEnable(AnalyzeDebug);
const ConfigurationWrapper = AuthenticationWithEnable(Configuration);
const FaceRecognitionWrapper = AuthenticationWithEnable(FaceRecognition);
const DataProjectsWrapper = AuthenticationWithEnable(DataProjects);
const CreateAutoClassificationWrapper = AuthenticationWithEnable(CreateAutoClassificationProject);
const AutoClassProjectStatusWrapper = AuthenticationWithEnable(AutoProjectView);
const ManualRefinementWrapper = AuthenticationWithEnable(ManualRefinement);
const RandomSamplerWrapper = AuthenticationWithEnable(RandomSampler);
const {REACT_APP_PRODUCT_FRUITS_KEY, REACT_APP_PRODUCT_FRUITS_LANGUAGE} = process.env;

const {CORE_PATH} = _requests;
const App = (props) => {
    const {initSentry} = useSentry();
    const { width } = useWindowDimensions();
    const {getViFeatures, showComponentCase} = useVIToggle();
    const [isNoConnection, setConnection] = useState(false);
    const [isLoaded, setIsLoad] = useState(false);
    const {isExpireToken, changeIsExpireToken, user} = props.userStore;
    const {imageIndex, setImageOnCanvas, ws, logOut, btnList} = props.siaStore;
    const {addToTogglesList, activeIndexToggle, togglesList, closeToggle} = useGlobalToggles();
    const {wsData, senWsdData} = useWebSocket(addToTogglesList);
    const disconnectUser = () => {
        storageService.saveToStorage('disconnected', true);
        const token = storageService.loadFromStorage('token');

        if (token) {
            request.sendBeacon(CORE_PATH.DISCONNECT_TAB, {'token': `${token}`}, false, false);
        }
    };
    const mainProps = (propsR) => ({
        ...props,
        ...propsR,
        wsData,
        screenWidth: width,
        addToTogglesList,
        getViFeatures,
        showComponentCase,
        senWsdData
    });
    const handleIfUserIsLogin = async () => {
        window.name !== 'tabLog' && storageService.removeFromStorage('token');
        if (storageService.loadFromStorage('token')) {
            await request.get(storageService.loadFromStorage('token'), 'CONNECT', false, '');
            storageService.removeFromStorage('disconnected');

            return await props.userStore.verifyUserToken();
        }
    };
    const resize = () => imageIndex > -1 && setImageOnCanvas(imageIndex);
    const online = () => {
        setConnection(false);
        ws.isActive && ws.reconnect();
    };
    const offline = () => setConnection(true);
    const findVisibilityBrowserEvent = async () => {
        if (storageService.loadFromStorage('token') && window.name === 'tabLog') {
            try {
                changeIsExpireToken(!(await props.userStore.verifyUserToken()));
            } catch (e) {
                changeIsExpireToken(true);
            }
        }
    };
    const getBaseName = () => {
        const filteredUrl = window.location.href.split(/[?&]/)[0]; // Remove query parameters

        if (filteredUrl.includes('/vis')) {
            return 'vis';
        }

        return '';
    };
    const reloadDataOnBackForwardButton = () => {
        const lastUrl = storageService.loadFromStorage('lastUrl');

        lastUrl && (window.location.href = `${lastUrl}`);
    };
    const removeAllWindowEvents = () => {

        window.removeEventListener('onunload', disconnectUser);
        window.removeEventListener('online', online);
        window.removeEventListener('offline', offline);
        window.removeEventListener('onfocus', findVisibilityBrowserEvent);
        window.removeEventListener('onpopstate', reloadDataOnBackForwardButton);
    };
    const addEventsAppListeners = () => {
        windowGlobalEvents.refreshPageDefault();
        window.addEventListener('resize', resize, true);
        window.addEventListener('online', online);
        window.addEventListener('offline', offline);
        window.onunload = disconnectUser;
        window.onfocus = findVisibilityBrowserEvent;
        window.onpopstate = reloadDataOnBackForwardButton;
    };

    useEffect(() => {
        resize();
    }, [width]);

    useEffect(() => {
        (async function() {
            try {
                await handleIfUserIsLogin();
                setIsLoad(true);
            } catch (e) {
                storageService.removeFromStorage('username');
                storageService.removeFromStorage('token');
                window.location.href = '/';
            }
        }());
        addEventsAppListeners();
        initSentry();

        return () => removeAllWindowEvents();
    }, []);


    return (
        <>
            {isLoaded && <>
                {storageService.loadFromStorage('username') &&
                    <ProductFruits
                        projectCode={REACT_APP_PRODUCT_FRUITS_KEY}
                        language={REACT_APP_PRODUCT_FRUITS_LANGUAGE}
                        username={storageService.loadFromStorage('username')}
                    />}
                <div id={`app-${user.osType || 'default'}`}>
                    {isExpireToken && <PopUp
                        title={tokenExpireModal.title}
                        type='mail'
                        subTitle={tokenExpireModal.subTitle}>
                        <img alt='wong request' src={wong} className='popup-img'/>
                        <div className={'btn-pop-up-expire'}>
                            <Button onClick={() => logOut(true)} classNameButton='top-md btn-main' setButtonToBeEnableAfterPress={btnList.logOut}>Login</Button>
                        </div>

                    </PopUp>}
                    {activeIndexToggle > -1 && togglesList[activeIndexToggle] && <WarningToggleSmall
                        close={closeToggle}
                        className={togglesList[activeIndexToggle].className}
                        title={togglesList[activeIndexToggle].title}
                        color={togglesList[activeIndexToggle].color} />}
                    {isNoConnection && !isExpireToken && <PopUp
                        title='No Internet Connection'
                        type='no-connection'
                        subTitle='Please connect to the internet and try again'>
                        <img alt='no internet' src={noInternet} className='popup-img'/>
                    </PopUp>}
                    <BrowserRouter basename={getBaseName()}>
                        <Suspense fallback={<Loading title='Loading' className='loading'/>}>
                            <Switch>
                                <Route exact path={['/', '/vis']} render={(propsR) => (storageService.loadFromStorage('token') && window.name === 'tabLog' ? <Redirect from='/' to={`${_SYSTEM_TITLES.projects}`} /> : <Login {...mainProps(propsR)} />)}/>
                                <Route exact path='/old_factory' render={(propsR) => (storageService.loadFromStorage('token')
                                    ? <AiFactory {...mainProps(propsR)} /> : <Login {...mainProps(propsR)} />)}/>
                                <Route exact path='/classification' render={(propsR) => (storageService.loadFromStorage('token')
                                    ? <ClassificationWrapper authenticationKey={'classification'} h1={'You don\'t have permissions for this page'} {...mainProps(propsR)} /> : <Login {...mainProps(propsR)} />)}/>
                                <Route exact path='/settings' render={(propsR) => (storageService.loadFromStorage('token') ? <SettingsWrapper authenticationKey={'tagging'} h1={'You don\'t have permissions for this page'} {...props} {...propsR}/> : <Login {...mainProps(propsR)} />)}/>
                                <Route exact path='/main' render={(propsR) => (storageService.loadFromStorage('token') && storageService.loadFromStorage('refresh') ? <Main {...mainProps(propsR)} /> : <h1>{'You don\'t have permissions for this page'}</h1>)} />
                                <Route exact path='/file_management' render={(propsR) => (storageService.loadFromStorage('token') && storageService.findPageAuthorizedOnStorage('file_management')
                                    ? <DataFileManagement {...mainProps(propsR)}/> : <h1>{'You don\'t have permissions for this page'}</h1>)} />
                                <Route exact path={['/tagging', '/evaluation']} render={(propsR) => (storageService.loadFromStorage('token') &&
                                    storageService.findPageAuthorizedOnStorage('tagging') ? (<Tagging {...mainProps(propsR)} />) : (<h1>You dont have permissions for this page</h1>))}/>
                                <Route exact path='/analyze_debug' render={(propsR) => (storageService.loadFromStorage('token')
                                    ? <AnalyzeDebugWrapper authenticationKey='management' h1={'You don\'t have permissions for this page'} {...mainProps(propsR)} /> : <Login {...mainProps(propsR)} />)}/>
                                <Route exact path='/configuration' render={(propsR) => (storageService.loadFromStorage('token')
                                    ? <ConfigurationWrapper authenticationKey='configurationPage' h1={'You don\'t have permissions for this page'} {...mainProps(propsR)} /> : <Login {...mainProps(propsR)} />)}/>
                                <Route exact path='/face_recognition' render={(propsR) => (storageService.loadFromStorage('token')
                                    ? <FaceRecognitionWrapper authenticationKey='faceRecognition' h1={'You don\'t have permissions for this page'} {...mainProps(propsR)}/> : <Login {...mainProps(propsR)} />)}/>
                                <Route exact path={[`/${_SYSTEM_TITLES.projects}`, `/${_SYSTEM_TITLES.deploy}`, `/${_SYSTEM_TITLES.classInventoryTabName}`]} render={(propsR) => (storageService.loadFromStorage('token')
                                    ? <DataProjectsWrapper authenticationKey='dataManagement' h1={'You don\'t have permissions for this page'} {...mainProps(propsR)}/> : <Login {...mainProps(propsR)} />)}/>
                                <Route exact path='/create_auto_classification_project' render={(propsR) => (storageService.loadFromStorage('token')
                                    ? <CreateAutoClassificationWrapper authenticationKey='dataManagement' h1={'You don\'t have permissions for this page'} {...mainProps(propsR)}/> : <Login {...mainProps(propsR)} />)}/>
                                <Route exact path='/auto_classification_project_status' render={(propsR) => (storageService.loadFromStorage('token')
                                    ? <AutoClassProjectStatusWrapper authenticationKey='dataManagement' h1={'You don\'t have permissions for this page'} {...mainProps(propsR)}/> : <Login {...mainProps(propsR)} />)}/>
                                <Route exact path='/auto_classification_manual_refinement' render={(propsR) => (storageService.loadFromStorage('token')
                                    ? <ManualRefinementWrapper authenticationKey='dataManagement' h1={'You don\'t have permissions for this page'} {...mainProps(propsR)}/> : <Login {...mainProps(propsR)} />)}/>
                                <Route exact path='/auto_classification_random_sampler' render={(propsR) => (storageService.loadFromStorage('token')
                                    ? <RandomSamplerWrapper authenticationKey='dataManagement' h1={'You don\'t have permissions for this page'} {...mainProps(propsR)}/> : <Login {...mainProps(propsR)} />)}/>
                                <Route render={(propsR) => (storageService.loadFromStorage('token') && window.name === 'tabLog' ? <Redirect from='/' to={`${_SYSTEM_TITLES.projects}`} /> : <Login {...mainProps(propsR)} />)}/>
                            </Switch>
                        </Suspense>
                    </BrowserRouter>
                </div>
                <div id={`${user.osType || 'default'}-error`}>
                    <p>{'This app doesn\'t support this screen size'}</p>
                </div>
            </>}
        </>
    );
};


export default inject('siaStore', 'userStore')(observer(App));
